import OptionsAnimImagesProps from "@/interfaces/optionsAnimImages";

export default function popUp(
  images: any,
  imagesTl: any,
  circles?: any,
  circleTl?: any,
  imageStyles?: { readonly [key: string]: string },
  sectionName?: string,
  isHero?: boolean,
  isCircleAnimated?: boolean,
  optionsAnimImages?: OptionsAnimImagesProps
) {
  if (optionsAnimImages?.arrowToReveal) {
    imagesTl.from(images, {
      stagger: 0.3,
      opacity: 0,
      onStart: () => {
        const arrows = document.querySelectorAll(`.${sectionName}-arrow`);

        arrows.forEach((el, i) => {
          setTimeout(() => {
            el.classList.add(imageStyles[`inView`]);
          }, 200 * (i + 1));
        });
      },
    });
  } else if (
    (isHero || isCircleAnimated) &&
    circles.length > 0 &&
    images.length > 0
  ) {
    imagesTl
      .from(circles, {
        stagger: 0.2,
        opacity: 0,
      })
      .from(
        images,
        {
          stagger: 0.2,
          opacity: 0,
        },
        "-=0.5"
      )
      .then(() => circleTl.play());
  } else if (images.length > 0) {
    imagesTl.from(images, {
      delay: () => (images.length > 1 ? 0 : 0.5),
      stagger: 0.2,
      opacity: 0,
    });
  }
}
